module.exports = __webpack_public_path__ + "assets/images/paralelepipedo_01b7f387482f65ceae8498faaebe1595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/paralelepipedo/paralelepipedo.png
// module id = 206
// module chunks = 0